import { IconButton, Menu } from "@mui/material";
import React, { Suspense, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import "./corevebCardv2.css";
import PremiumOverviewContainer from "../PremiumOverviewV2/PremiumOverviewV2";
import { CorePanhandlePlansName, CorePlansName, VEB_PLAN_ARRAY } from "../../../../constants/plan";
import DependentMenuItems from "../menuItemsv2/DependentMenuItems";
import RidersMenuItems from "../menuItemsv2/RidersMenuItems";
import EnrollmentIInfoGrid from "../enrollmentInfoGridv2/EnrollmentIInfoGrid";
import { coreVEBBenefitsProps } from "../../../../types/enrollmentV2.types";
import BeneficiaryMenuItems from "../menuItemsv2/BeneficiaryMenuItems";
import { formatTwoDecimalPlaces } from "../../../../utils/commonFunctions/decimal";
import { GROUP_NUMBER } from "../../../../constants/groups";
import CustomModal from "../../customModal/CustomModal";
import EditBeneficiaryForm from "./editBeneficiaryForm/EditBeneficiaryForm";

const CoreVebCard: React.FC<coreVEBBenefitsProps> = ({
	backgroundImage,
	plan_code,
	plan_name,
	base_plan_name,
	enrollment_status,
	total_premium,
	effective_date,
	benefit_end_date,
	termination_date,
	enrollment_date,
	initial_effective_date,
	enrollments,
	coreTrueCount,
	vebTrueCount,
	coreDependents,
	vebDependents,
	vebRiderCount,
	vebRiders,
	sub_plan
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [isOpen, setIsOpen] = useState(false);
	const [overallPremiumAnchorEl, setOverallPremiumAnchorEl] = useState<null | HTMLElement>(null);
	const [noDependentsAnchorEl, setNoDependentsAnchorEl] = useState<null | HTMLElement>(null);
	const [vebRiderMenuAnchorEl, setVebRiderMenuAnchorEl] = useState<null | HTMLElement>(null);
	const [beneficiaryMenuAnchorEl, setBeneficiaryMenuAnchorEl] = useState<null | HTMLElement>(null);

	const [editBeneficiaryModalOpen, setEditBeneficiaryModalOpen] = useState<boolean>(false);

	const open = Boolean(anchorEl);
	const overallPremiumOpenStatus = Boolean(overallPremiumAnchorEl);
	const noDependentsOpenStatus = Boolean(noDependentsAnchorEl);
	const beneficiaryMenuOpenStatus = Boolean(beneficiaryMenuAnchorEl);
	const isPanhandle = enrollments.length > 0 && enrollments[0].group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK;
	const isProgressiveLab =
		enrollments.length > 0 && enrollments[0].group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES;
	const isCorePanHandlePlan = isPanhandle && CorePanhandlePlansName.includes(plan_name);

	const handleOpenCloseEditBeneficiaryModal = () => {
		// eslint-disable-next-line arrow-parens
		setEditBeneficiaryModalOpen((editBeneficiaryModalOpen) => !editBeneficiaryModalOpen);
	};

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		if (CorePlansName.includes(plan_name) || isCorePanHandlePlan) {
			// console.log("before");
			if (enrollments.length > 1 && coreTrueCount[plan_code] >= 1) {
				// console.log("after");
				setIsOpen(!isOpen);
				setAnchorEl(event.currentTarget);
			} else {
				setNoDependentsAnchorEl(event.currentTarget);
			}
		} else {
			// // console.log("before 2", vebTrueCount[plan_name]);
			if (enrollments.length > 1 && vebTrueCount[plan_code] >= 1) {
				// // console.log("before 2 5");
				setIsOpen(!isOpen);
				// // console.log("before 2", isOpen);
				setAnchorEl(event.currentTarget);
			} else {
				// // console.log("before 3", enrollments, vebTrueCount);
				setNoDependentsAnchorEl(event.currentTarget);
			}
		}
	};

	const handleOpenPremiumClick = (event: React.MouseEvent<HTMLElement>) => {
		setOverallPremiumAnchorEl(event.currentTarget);
	};

	const handleVebRiderMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		setVebRiderMenuAnchorEl(event.currentTarget);
	};

	const handleVebRiderMenuClose = () => {
		setVebRiderMenuAnchorEl(null);
	};

	const handleBeneficiaryMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		setBeneficiaryMenuAnchorEl(event.currentTarget); // Set anchor for beneficiary menu
	};

	const handleBeneficiaryMenuClose = () => {
		setBeneficiaryMenuAnchorEl(null); // Close beneficiary menu
	};

	const handleClosePremiumPop = () => setOverallPremiumAnchorEl(null);
	const handleClose = () => {
		setAnchorEl(null);
		setIsOpen(false);
		setNoDependentsAnchorEl(null);
	};

	const premiumDetails = {
		health_plan: [
			{ type: "Standard", premium_amount: 60 },
			{ type: "Child", premium_amount: 72 },
			{ type: "Spouce", premium_amount: 55 }
		]
	};

	// Function to get dependents count for a specific plan
	const getDependentsCount = (planName: string, dependents: any) => {
		// console.log("=========DependentCount==>", planName, dependents);
		// eslint-disable-next-line arrow-parens
		// return dependents.filter((dependent) => dependent.plan_name === planName).length;
		// // console.log("DependentCount======>", vebTrueCount);
		return vebTrueCount[planName];
	};
	const getCoreDependentsCount = (planName: string, dependents: any) => {
		// console.log("=========DependentCount==>", planName, dependents);
		// eslint-disable-next-line arrow-parens
		// return dependents.filter((dependent) => dependent.plan_name === planName).length;
		// // console.log("DependentCount======>", vebTrueCount);
		return coreTrueCount[planName];
	};

	// Function to get dependents count for a specific plan
	const getDependentsDetails = (planName: string, dependents: any) => {
		// eslint-disable-next-line arrow-parens
		// return dependents.filter((dependent) => dependent.plan_name === planName);
		// // console.log("specificDependentsv3", planName, dependents, dependents[planName]);
		if (dependents[planName]) {
			// // console.log("=======>vebDependents", dependents, dependents[planName]);

			return dependents[planName];
		} else {
			// // console.log("vebDependents", dependents, dependents[planName]);
			return [];
		}
	};

	// Prepare dependent data for the specific plan
	const specificDependents =
		CorePlansName.includes(plan_name) || isCorePanHandlePlan
			? getDependentsDetails(plan_code, coreDependents)
			: getDependentsDetails(plan_code, vebDependents);
	// eslint-disable-next-line arrow-parens
	// const dependentItem = specificDependents.map((dependent) => ({
	// 	name: dependent.member.first_name + " " + dependent.member.last_name,
	// 	label: dependent.member.relationship,
	// 	amount: `$${dependent.premium_amount}`
	// }));
	// console.log("specificDependentsv2", specificDependents);

	const dependentProgressiveLabItem = specificDependents
		?.filter((dependent: any) => dependent.plan_code == plan_code)
		.map((dependent: any) => ({
			name: dependent.member.first_name + " " + dependent.member.last_name,
			label: dependent.member.relationship
			// amount: `$${dependent.premium_amount}`
		}));

	// Prepare rider data for the specific plan
	// const specificRiders = getRiderDetails(plan_name, vebRiders);

	// // eslint-disable-next-line arrow-parens
	const riderItem = vebRiders[plan_code]?.map((rider: any) => ({
		name: rider.member.first_name + " " + rider.member.last_name,
		riderName: rider.plan_name,
		label: rider.member.relationship,
		amount: `$${rider.premium_amount}`
	}));
	// console.log(riderItem, "vebRiders");
	const specificBeneficiaries = enrollments
		// eslint-disable-next-line arrow-parens
		.filter((enrollment: { VEB_primary_beneficiary: any }) => enrollment.VEB_primary_beneficiary)
		// eslint-disable-next-line arrow-parens
		.map((enrollment: { VEB_primary_beneficiary: any[] }) =>
			// eslint-disable-next-line arrow-parens
			enrollment.VEB_primary_beneficiary.map((beneficiary) => ({
				name: beneficiary.first_name + " " + beneficiary.last_name,
				relationship: beneficiary.relationship,
				percentage: `${beneficiary.percentage}%`,
				type: beneficiary.type
			}))
		)
		.flat();

	// console.log(
	// 	"testing done hi",

	// 	vebTrueCount,
	// 	vebDependents
	// );

	return (
		<div className="inner-card-info">
			<div>
				<div className="image-ribbion-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
					<span
						className="sponsored-ribbon"
						style={
							CorePlansName.includes(plan_name) || isCorePanHandlePlan
								? { background: "linear-gradient(to right, #f40752, #f9ab8f)" }
								: { background: "linear-gradient(to right, #8a2be2, #d8bfd8)" }
						}
					>
						{CorePlansName.includes(plan_name) || isCorePanHandlePlan ? "Core Plan" : "Veb Plan"}
						<div className="glows"></div>
					</span>
				</div>
			</div>
			<Suspense fallback={<div />}>
				<CustomModal open={editBeneficiaryModalOpen} onClose={handleOpenCloseEditBeneficiaryModal} title="">
					<EditBeneficiaryForm
						handleOpenCloseEditBeneficiaryModal={handleOpenCloseEditBeneficiaryModal}
						plan_type={CorePlansName.includes(plan_name) || isCorePanHandlePlan ? "core" : "VEB"}
						plan_code={plan_code}
						plan_name={plan_name}
						base_plan_name={base_plan_name}
						enrollments={enrollments}
					/>
				</CustomModal>
			</Suspense>
			<div style={{ flex: "1" }}>
				<div className="inner-card-info">
					<h2
						style={{
							fontWeight: "bold",
							fontSize: "23px",
							marginBottom: "3px",
							marginTop: "3px"
						}}
					>
						📌{plan_name}
						<span
							className="active-ribbon"
							style={{
								backgroundColor:
									enrollment_status === "SUBMITTED"
										? "#0891b2"
										: enrollment_status === "WAITING"
										? "#f59e0b"
										: enrollment_status === "ACTIVE"
										? "green"
										: ""
							}}
						>
							{enrollment_status}
						</span>
						<span
							style={{
								display: "block",
								color: "red",
								fontWeight: "bold",
								width: "fit-content",
								fontSize: "15px",
								marginLeft: "30px"
							}}
						>
							{plan_code}
						</span>
					</h2>

					<div style={{ display: "flex", alignItems: "center" }}>
						<div>
							<p>
								Total Premium
								{isPanhandle || isProgressiveLab ? (
									<span style={{ padding: "0 8px" }}>:</span>
								) : (
									<IconButton onClick={handleOpenPremiumClick}>
										<FaInfoCircle size={18} />
									</IconButton>
								)}
							</p>
							<PremiumOverviewContainer
								open={overallPremiumOpenStatus}
								anchorEl={overallPremiumAnchorEl}
								handleClose={handleClosePremiumPop}
								premiumDetails={premiumDetails}
								enrollment={enrollments}
							/>
						</div>
						<span
							style={{
								fontSize: "26px",
								color: "green",
								fontWeight: "1000"
							}}
						>
							${formatTwoDecimalPlaces(total_premium)}
						</span>
						<div style={{ marginLeft: 20 }}>
							{dependentProgressiveLabItem && (
								<Menu
									id="basic-menu"
									anchorEl={anchorEl}
									open={open}
									onClose={handleClose}
									MenuListProps={{
										"aria-labelledby": "basic-button"
									}}
								>
									{/* <DependentMenuItems items={dependentItem} /> */}
									<DependentMenuItems items={dependentProgressiveLabItem} />
								</Menu>
							)}
							{vebRiders && vebRiders[plan_code] && (
								<Menu
									anchorEl={vebRiderMenuAnchorEl}
									open={Boolean(vebRiderMenuAnchorEl)}
									onClose={handleVebRiderMenuClose}
								>
									<RidersMenuItems items={riderItem} />
								</Menu>
							)}
							<Menu
								anchorEl={beneficiaryMenuAnchorEl}
								open={beneficiaryMenuOpenStatus}
								onClose={handleBeneficiaryMenuClose}
							>
								<BeneficiaryMenuItems items={specificBeneficiaries} />
							</Menu>
						</div>
					</div>
				</div>

				<EnrollmentIInfoGrid
					handleOpenCloseEditBeneficiaryModal={handleOpenCloseEditBeneficiaryModal}
					plan_code={plan_code}
					plan_name={plan_name}
					base_plan_name={base_plan_name}
					sub_plan={sub_plan}
					enrollment_date={enrollment_date}
					initial_effective_date={initial_effective_date}
					effective_date={effective_date}
					benefit_end_date={benefit_end_date}
					termination_date={termination_date}
					coreDependentsCount={getCoreDependentsCount(plan_code, coreDependents)}
					vebDependentsCount={getDependentsCount(plan_code, vebDependents)}
					coreTrueCount={coreTrueCount[plan_code]}
					vebTrueCount={vebTrueCount[plan_code]}
					vebRiderCount={vebRiderCount[plan_code]}
					handleClick={handleClick}
					handleVebRiderMenuClick={handleVebRiderMenuClick}
					enrollmentsLength={enrollments.length}
					enrollments={enrollments}
					handleVebBeneficiaryMenuClick={handleBeneficiaryMenuClick}
				/>
			</div>
		</div>
	);
};

export default CoreVebCard;
